import { useEffect } from "react";

import { isIOSVersionUntil11 } from "@/shared/utils/device-detect";

const prefix = "ios-until-";

const useIOSGlobalClassNames = () => {
  useEffect(() => {
    const bodyClassList = document.documentElement.classList;

    if (isIOSVersionUntil11()) {
      bodyClassList.add(prefix + "11");
    } else {
      bodyClassList.remove(prefix + "11");
    }
  }, []);
};

export default useIOSGlobalClassNames;
